<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col sm="12">
        <b-card header="Reporte mensual">

          <b-row class="form-group">
            <b-col cols="12">
              <div class="pull-left">
                <input type="text" v-model="search" class="form-control" placeholder="Buscar"/>
              </div>
              <div class="pull-right">
                <b-form @submit.prevent="getReport()">
                  <date-picker
                    v-model="startMonth"
                    lang="es"
                    type="month"
                    placeholder="Desde"
                    format="MM/YYYY"
                  ></date-picker>&nbsp;
                  <date-picker
                    v-model="endMonth"
                    lang="es"
                    type="month"
                    placeholder="Hasta"
                    format="MM/YYYY"
                  ></date-picker>&nbsp;
                  <input type="submit" class="btn btn-primary" value="Buscar"/>&nbsp;
                  <!-- <a class="btn btn-success" @click="saveMonthlyRatio()"><i class="fa fa-money"></i> Liquidar mes</a> -->
                </b-form>
              </div>
            </b-col>
          </b-row>

          <b-row v-if="loading">
            <b-col cols="12">
              <div class="fa-2x center">
                <span class="fa fa-spinner fa-spin"></span>
              </div>
            </b-col>
          </b-row>

          <div class="table-responsive">
            <table class="table table-bordered table-sm table-striped table-hover">
              <thead>
              <tr>
                <th rowspan="2">PLACA</th>
                <!-- <th rowspan="2">TIPO DE PAGO</th> -->
                <!-- <th rowspan="2">PLACA</th> -->
                <th v-for="(month, m) in months" :key="`mo${m}`" colspan="3">
                  {{ month.locale('es').format('MMM YYYY') }}
                </th>
                <th colspan="4" style="background: #d7e3f7;">TOTALES</th>
                <th :colspan="months.length" style="background: #d4f5e3;">% DISPONIBILIDAD DE DIAS AL MES</th>
              </tr>
              <tr>
                <th v-for="(item, i) in items" :key="`item${i}`">
                  {{item.name}}
                </th>
                <th style="background: #d7e3f7;">Viajes</th>
                <th style="background: #d7e3f7;">Dias</th>
                <th style="background: #d7e3f7;">Ratio dia</th>
                <th style="background: #d7e3f7;">% Dias mes</th>
                <th v-for="(month, k) in months" :key="`m${k}`" style="background: #d4f5e3;">
                  {{ month.locale('es').format('MMM YY') }}
                </th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(truck, t) in trucksFiltered" :key="`t${t}`">
                <td>
                  {{truck.plate}}<br>
                  <span class="text-muted" style="font-size: 9px;">{{truck.provider.name}}</span>
                </td>
                <td v-for="(item, r) in items" :key="`ti${t+r}`">
                  {{ getCount(item, truck.id) }}
                </td>
                <td style="background: #d7e3f7;">{{ getTotalRqs(truck.id) }}</td>
                <td style="background: #d7e3f7;">{{ getTotalDays(truck.id) }}</td>
                <td style="background: #d7e3f7;">{{ getTotalRatio(truck.id) }}</td>
                <td style="background: #d7e3f7;">{{ (getTotalDays(truck.id) / months.length).toFixed(1) }}</td>
                <td v-for="(month, mo) in months" :key="`tmo${t+mo}`" style="background: #d4f5e3;">
                  {{ getPercentageByMonth(month, truck.id) }}
                </td>
              </tr>
              </tbody>
            </table>
          </div>

        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import api from '@/helpers/api'
  import moment from 'moment'
  import constants from '@/constants'

  export default {
    name: 'RatioAssistance',
    data() {
      return {
        startMonth: moment(),
        endMonth: moment(),
        loading: false,
        ratios: [],
        months: [],
        trucks: [],
        items: [],
        search: ''
      }
    },
    mounted() {
      api.get('/trucks').then(response => {
        console.log(response)
        this.trucks = response.trucks.filter(t => t.service.code == constants.PORTEO)
      })
      this.getReport()
    },
    computed: {
      trucksFiltered() {
        return this.trucks.filter(truck => {
          let text = this.search.toLowerCase()
          let condition = true
          if (text) {
            condition = truck.plate.toLowerCase().includes(text) ||
              truck.provider.name.toLowerCase().includes(text)
          }
          return condition
        })
      }
    },
    methods: {
      getReport() {
        let month = moment(this.startMonth).startOf('month')
        this.months = []
        this.items = []
        while (month <= this.endMonth) {
          this.items.push(
            {
              month,
              name: 'Viaje',
              code: 'rqs'
            },
            {
              month,
              name: 'Dias',
              code: 'days'
            },
            {
              month,
              name: 'Ratio',
              code: 'rt'
            }
          )
          this.months.push(month);
          month = month.clone().add(1, "M").startOf('month');
        }
        let data = {
          start_month: moment(this.startMonth).format('YYYY-MM-01'),
          end_month: moment(this.endMonth).format('YYYY-MM-01')
        }
        api.post('/monthly_ratio', data).then(response => {
          this.ratios = response.ratios
        })
      },
      getCount(item, truck_id) {
        // return truck_id+' '+item.code+' '+moment(item.month).format('YYYY-MM');
        let ratio = this.ratios.find(r => r.month == moment(item.month).format('YYYY-MM-01'))
        let total = 0
        if (ratio) {
          let rt = ratio.ratio_trucks.find(t => t.truck_id == truck_id)
          switch (item.code) {
            case 'rqs':
              total = rt.total_rqs;
              break
            case 'days':
              total = rt.days;
              break
            case 'rt':
              if (rt.days > 0) {
                total = (rt.total_rqs / rt.days).toFixed(1)
              }
              break;
          }
        }
        return total
      },
      getTotalRqs(truck_id) {
        return this.ratios.reduce((r, ratio) => {
          let rt = ratio.ratio_trucks.find(t => t.truck_id == truck_id)
          return rt.total_rqs + r
        }, 0)
      },
      getTotalDays(truck_id) {
        return this.ratios.reduce((r, ratio) => {
          let rt = ratio.ratio_trucks.find(t => t.truck_id == truck_id)
          return rt.days + r
        }, 0)
      },
      getTotalRatio(truck_id) {
        let total_rqs = this.getTotalRqs(truck_id)
        let days = this.getTotalDays(truck_id)
        return days > 0 ? (total_rqs / days).toFixed(1) : 0
      },
      getPercentageByMonth(month, truck_id) {
        let ratio = this.ratios.find(r => r.month == moment(month).format('YYYY-MM-01'))
        let days_in_month = moment(month, "YYYY-MM").daysInMonth()
        let percentage = 0
        if (ratio) {
          let rt = ratio.ratio_trucks.find(t => t.truck_id == truck_id)
          percentage = (rt.days / days_in_month) * 100
        }
        return percentage.toFixed(1)
      }
    }
  }
</script>

<style scope>
  table {
    text-align: left !important;
    position: relative !important;
    border-collapse: collapse;
  }

  th {
    position: sticky !important;
    top: 0;
    /* box-shadow: 0 2px 2px -1px rgba(0, 0, 0, 0.4); */
  }
</style>
